import axiosInstance from '@api';

/**
 * Dash 사용자의 역할에 따라 다른 목록을 출력한다.
 * @param search
 * @returns
 */
export const dash = () => axiosInstance.get('/dash');
